import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import GamecategoryList from "./GameProviderList";
import { paginatedProvidersList } from "../../services/axios/apiManager";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import { useAppContext } from "../../services/context";

const GameProvider = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  const [gameProviders, setGameProviders] = useState([]);
  const [pagination, setPagination] = useState({});

  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Game_Providers");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await paginatedProvidersList();
    if (res?.data?.success && res?.data?.data) {
      setGameProviders(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Providers List:");
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div data-testid="gameProviders">
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>System Settings</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#8b8b8cbf" }}
                >
                  Game Providers
                </li>
              </ol>
            </div>
          </div>
        </div>

        <GamecategoryList
          gameProviders={gameProviders}
          setGameProviders={setGameProviders}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default GameProvider;
